const { applySections, on } = window.nt;

/**
 * <cart-drawer> — the cart as a side panel, built on a native <dialog>.
 *
 * It opens when the visitor clicks a cart trigger (the cart icon of the header, anything with data-cart-trigger)
 * and whenever an item is added. The dialog gives focus trapping, the Escape key and the backdrop for free.
 * Changes made inside the drawer are handled by <cart-items>; adds made elsewhere arrive as "cart:updated"
 * events that carry the fresh drawer markup.
 */
class CartDrawer extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');

    document.addEventListener('click', this.onDocumentClick);
    this.dialog.addEventListener('click', this.onDialogClick);
    this.stopListening = on('cart:updated', this.onCartUpdated);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    this.stopListening?.();
  }

  onDocumentClick = (event) => {
    if (event.target.closest('[data-cart-trigger]')) {
      event.preventDefault();
      this.open();
    }
  };

  onDialogClick = (event) => {
    // A click on the backdrop lands on the dialog element itself; a click on a close button is explicit.
    if (event.target === this.dialog || event.target.closest('[data-cart-close]')) this.close();
  };

  onCartUpdated = (event) => {
    const { source, sections } = event.detail;
    if (source === 'cart-items') return;

    applySections(sections);
    this.open();
  };

  open() {
    if (!this.dialog.open) this.dialog.showModal();
  }

  close() {
    if (this.dialog.open) this.dialog.close();
  }
}

if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);
